import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cyclops-brand',
  templateUrl: './cyclops-brand.component.html',
  styleUrls: ['./cyclops-brand.component.scss']
})
export class cyclopsBrandComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  brands = [
    // { img: "assets/images/clients/datron_world_communications_logo.jpg" },
    { img: "assets/images/clients/lebarm.png" },
    { img: "assets/images/clients/Lesser_Coat_of_Arms_of_Ukraine.png" },
    { img: "assets/images/clients/dsc.jpg" },
    { img: "assets/images/clients/United_States_Army.png" },
    { img: "assets/images/clients/Egyptian_Air_Force_emblem.png" },
    { img: "assets/images/clients/BlueHalo_Logo_ForPrint-CMYK_FULL_Duo-Tone.jpg" } ,
    { img: "assets/images/clients/usforce.png" } ,
    { img: "assets/images/clients/Jordanian_Armed_Forces.png" } ,
    { img: "assets/images/clients/Armed_Forces_of_Saudi_Arabia_Emblem.png" },
    { img: "assets/images/clients/Seal_of_the_United_States_Department_of_Defense.png" },
    { img: "assets/images/clients/AV.png" } ,
    { img: "assets/images/clients/Soc.png" } ,
    {img: "assets/images/clients/martin.png" } ,
    {img: "assets/images/clients/bloman.png" } ,


  ]
  
  brandcarouselOptions= {
    items: 6,
    margin: 50,
    autoHeight: true,
    nav: false,
    dots: false,
    autoplay: true,
    slideSpeed: 300,
    paginationSpeed: 400,
    loop: true,
    responsive: {
        0: {
            items: 2,
            margin: 10
        },
        320: {
            items: 3,
            margin: 10
        },
        480:{
            items: 4,
            margin: 30
        },
        768:{
            items: 5,
            margin: 50
        },
        1200: {
            items: 6,
            margin: 50
        }
    }
  }


}
